const PRESENT_TYPE = {
  MENU: {
    color: 'blue',
    label: '메뉴',
    value: 'MENU',
  },
  PRODUCT: {
    color: 'purple',
    label: '상품',
    value: 'PRODUCT',
  },
  // CASH_VOUCHER: {
  //   color: 'red',
  //   label: '금액권',
  //   value: 'CASH_VOUCHER',
  // },
  AMOUNT: {
    color: 'red',
    label: '금액권',
    value: 'AMOUNT',
  },
};

const PRESENT_PROVIDER_TYPE = {
  JM: { text: '제이엠', value: 'JM' },
  OTHER: { text: '외부', value: 'OTHER' },
};
const PRESENT_YES_OR_NO = {
  Y: { SENT: { text: '성공', value: 'Y' }, SHOW: { text: '노출', value: 'Y' } },
  N: {
    SENT: { text: '실패', value: 'N' },
    SHOW: { text: '미노출', value: 'N' },
  },
};
export { PRESENT_TYPE, PRESENT_PROVIDER_TYPE, PRESENT_YES_OR_NO };
